import type { PropsWithChildren, ReactNode } from 'react';

interface PageProps extends PropsWithChildren {
  actions?: ReactNode;
  description?: string;
  eyebrow?: string;
  title: string;
}

export function Page({
  actions,
  children,
  description,
  eyebrow,
  title,
}: PageProps) {
  return (
    <article className="page">
      <header className="page-header">
        <div>
          {eyebrow === undefined ? null : <p className="eyebrow">{eyebrow}</p>}
          <h1>{title}</h1>
          {description === undefined ? null : (
            <p className="page-header__description">{description}</p>
          )}
        </div>
        {actions === undefined ? null : (
          <div className="page-header__actions">{actions}</div>
        )}
      </header>
      {children}
    </article>
  );
}

interface CardProps extends PropsWithChildren {
  className?: string;
  title?: string;
}

export function Card({ children, className = '', title }: CardProps) {
  const classes = ['card', className].filter(Boolean).join(' ');

  return (
    <section className={classes}>
      {title === undefined ? null : <h2>{title}</h2>}
      {children}
    </section>
  );
}
